import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner2-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import pp1 from "../assets/Images/pp1.png";
import pp2 from "../assets/Images/pp2.png";
import pp3 from "../assets/Images/pp3.png";
import pp4 from "../assets/Images/pp4.png";
import pp5 from "../assets/Images/pp5.png";
import pp6 from "../assets/Images/pp6.png";
import pp7 from "../assets/Images/pp7.png";
import pp8 from "../assets/Images/pp8.png";
import pp9 from "../assets/Images/pp9.png";
import { useTranslation } from "react-i18next";
import "./WhoNeedsServicePage.scss";

const WhoNeedsServicePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("who_needs_service_page_header")}</h1>
          <p className="banner-subtitle">{t("who_needs_service_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_who_needs_service_page_link1")}</Link>
        <span>{t("breadcrumbs_who_needs_service_page_span")}</span>
        <Link>{t("breadcrumbs_who_needs_service_page_link2")}</Link>
      </Breadcrumbs>
      <main className="services-main-container">
        <header className="services-header">
          <h2 className="services-main-title">{t("who_needs_service_page_h2")}</h2>
          <p className="services-intro-text">{t("who_needs_service_page_text1")}</p>
          <p className="services-subtitle">{t("who_needs_service_page_text2")}</p>
        </header>
        
        <section className="services-grid">
          <div className="service-item">
            <img src={pp1} alt="Service type 1" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text3")}</span>
          </div>
          <div className="service-item">
            <img src={pp2} alt="Service type 2" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text6")}</span>
          </div>
          <div className="service-item">
            <img src={pp3} alt="Service type 3" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text5")}</span>
          </div>
          <div className="service-item">
            <img src={pp4} alt="Service type 4" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text4")}</span>
          </div>
          <div className="service-item">
            <img src={pp5} alt="Service type 5" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text7")}</span>
          </div>
          <div className="service-item">
            <img src={pp6} alt="Service type 6" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text8")}</span>
          </div>
          <div className="service-item">
            <img src={pp7} alt="Service type 7" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text12")}</span>
          </div>
          <div className="service-item">
            <img src={pp8} alt="Service type 8" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text10")}</span>
          </div>
          <div className="service-item">
            <img src={pp9} alt="Service type 9" className="service-icon" />
            <span className="service-text">{t("who_needs_service_page_text11")}</span>
          </div>
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default WhoNeedsServicePage;
